/*global location*/
function changeModule({ input }) {
  window.location.replace(`http://${window.location.host}/${input.name}`)
}

export default changeModule



// WEBPACK FOOTER //
// ./src/modules/user/actions/changeModule.js